<div class="bordered" *ngIf="list.itemCount">
  <table>
    <thead class="sticky">
    <tr>
      <th *ngIf="isChecked" [attr.rowspan]="rowspan"><gmt-checkbox [gmtChecked]="inverseSelection" (click)="onCheckAll()"></gmt-checkbox></th>
      <th *ngIf="!hideColumn('lv')" class="nowrap" [attr.rowspan]="rowspan">
        <sort-by [selected]="'parcel.title.lv' === list.filter.sortOrder.sortBy" (sort)="onSort('parcel.title.lv', $event)" [sortDir]="list.filter.sortOrder.direction">LV</sort-by>
      </th>
      <th *ngIf="!hideColumn('zabkutx')" class="nowrap" [attr.rowspan]="rowspan">
        <sort-by [selected]="'zabkutx' === list.filter.sortOrder.sortBy" (sort)="onSort('zabkutx', $event)" [sortDir]="list.filter.sortOrder.direction">K.Ú.</sort-by>
      </th>
      <th *ngIf="!hideColumn('ownerships')" [attr.rowspan]="rowspan">Vlastník</th>
      <th *ngIf="!hideColumn('zabcis')" [attr.rowspan]="rowspan">
        <sort-by [selected]="'zabcis' === list.filter.sortOrder.sortBy" (sort)="onSort('zabcis', $event)" [sortDir]="list.filter.sortOrder.direction">Číslo</sort-by>
      </th>
      <th *ngIf="!hideColumn('zabst')" [attr.rowspan]="rowspan">
        <sort-by [selected]="'zabst' === list.filter.sortOrder.sortBy" (sort)="onSort('zabst', $event)" [sortDir]="list.filter.sortOrder.direction">{{ 'ETAPA_USEK' | wordtranslate }}</sort-by>
      </th>
      <th *ngIf="!hideColumn('nabyvatel')" [attr.rowspan]="rowspan">
        <sort-by [selected]="'nabyvatel' === list.filter.sortOrder.sortBy" (sort)="onSort('nabyvatel', $event)" [sortDir]="list.filter.sortOrder.direction">Nabyvatel</sort-by>
      </th>
      <th *ngIf="!hideColumn('investor')" [attr.rowspan]="rowspan">
        <sort-by [selected]="'investor' === list.filter.sortOrder.sortBy" (sort)="onSort('investor', $event)" [sortDir]="list.filter.sortOrder.direction">Investor</sort-by>
      </th>
      <th *ngIf="!hideColumn('parcel')" [attr.rowspan]="rowspan">Parcela</th>
      <th [attr.rowspan]="rowspan">
        <sort-by [selected]="list.filter.sortOrder.sortBy === 'finalSolutionType.name'" (sort)="onSort('finalSolutionType.name', $event)" [sortDir]="list.filter.sortOrder.direction">Způsob vypořádání záboru</sort-by>
      </th>
      <th [attr.rowspan]="rowspan">
        <sort-by [selected]="list.filter.sortOrder.sortBy === 'finalSolutionState'" (sort)="onSort('finalSolutionState', $event)" [sortDir]="list.filter.sortOrder.direction">Schválení způsobu vypořádání záboru</sort-by>
      </th>
      <th *ngIf="!hideColumn('cases')" [attr.rowspan]="rowspan">
        <sort-by [selected]="'countCases' === list.filter.sortOrder.sortBy" (sort)="onSort('countCases', $event)" [sortDir]="list.filter.sortOrder.direction">Případy</sort-by>
      </th>
      <th *ngIf="!hideColumn('constructionObjects')" [attr.rowspan]="rowspan">{{ 'CONCERN_CONSTRUCTION_OBJECT_SHORTCUT' | wordtranslate:true }}</th>
      <th
        *ngIf="occupationTypesPermanent.length > 0"
        [ngClass]="{ 'bordered-bottom': shouldDrawSecondRowOf(occupationTypesPermanent) }"
        [attr.colspan]="occupationTypesPermanent.length"
        [attr.rowspan]="permanentOccupationRowspan"
      >{{ 'PERMANENT_OCCUPATION' | wordtranslate }} [<span class="unit">m<sup>2</sup></span>]</th>
      <th
        *ngIf="occupationTypesTemporary.length > 0"
        [ngClass]="{ 'bordered-bottom': shouldDrawSecondRowOf(occupationTypesTemporary) }"
        [attr.colspan]="occupationTypesTemporary.length"
        [attr.rowspan]="temporaryOccupationRowspan"
      >{{ 'TEMPORARY_OCCUPATION' | wordtranslate }} [<span class="unit">m<sup>2</sup></span>]</th>
    </tr>
    <tr *ngIf="shouldHaveSecondRow()">
      <ng-container *ngIf="shouldDrawSecondRowOf(occupationTypesPermanent)">
        <th class="column-8" *ngFor="let occupationType of occupationTypesPermanent">{{ occupationType.name }}</th>
      </ng-container>
      <ng-container *ngIf="shouldDrawSecondRowOf(occupationTypesTemporary)">
        <th class="column-8" *ngFor="let occupationType of occupationTypesTemporary">{{ occupationType.name }}</th>
      </ng-container>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let occupation of list.list" (click)="onToggleCheckItem(occupation)" class="clickable">
      <td *ngIf="isChecked" class="text-center"><gmt-checkbox [gmtChecked]="isChecked(occupation) !== inverseSelection"></gmt-checkbox></td>
      <td *ngIf="!hideColumn('lv')" class="number">{{ occupation.parcel?.title?.lv }}</td>
      <td *ngIf="!hideColumn('zabkutx')">{{ occupation.zabkutx }}</td>
      <td *ngIf="!hideColumn('ownerships')" class="no-padding cell-max-height">
        <ng-container *ngIf="occupation.parcel.title">
          <cell-ownership
            [count]="occupation.parcel.title.countOwnerships"
            [ownerships]="occupation.parcel.title.ownerships"
            [tooltipData]="{ filter: {sortOrder: {sortBy: 'subjectName'}, filters: { titleId: occupation.parcel.title.id, validity: 'valid' }}, attributes: {subject: {load: false}}}"
            [tooltipType]="'ownership-list'"
          ></cell-ownership>
        </ng-container>
      </td>
      <td *ngIf="!hideColumn('zabcis')" class="number" [ngClass]="{ cancelled: !!occupation.endDate }">{{ occupation.zabcis }}</td>
      <td *ngIf="!hideColumn('zabst')" class="number" [ngClass]="{ cancelled: !!occupation.endDate }">{{ occupation.zabst }}</td>
      <td *ngIf="!hideColumn('nabyvatel')">{{ occupation.nabyvatel }}</td>
      <td *ngIf="!hideColumn('investor')">{{ occupation.investor }}</td>
      <td *ngIf="!hideColumn('parcel')">
        {{ occupation.parcel?.parcisKmen }}<span *ngIf="occupation.parcel?.parcisPod">/{{ occupation.parcel.parcisPod }}</span>
      </td>
      <td>
        {{ occupation.occupationType?.category === 'permanent'
          ? (occupation.finalSolutionType?.name || 'Stav EMH')
          : '' }}
      </td>
      <td class="no-padding cell-max-height">
        <div class="fill-content flexbox-container flex-centered no-wrap p-10">
          <span *ngIf="occupation?.finalSolutionState === FinalSolutionStateEnum.APPROVED" class="tag tag--active tag--inline is-uppercase tag--not-clickable tag-solution">Schváleno</span>
          <span *ngIf="occupation?.finalSolutionState === FinalSolutionStateEnum.REJECTED" class="tag tag--danger tag--inline is-uppercase tag--not-clickable tag-solution">Zamítnuto</span>
          <span *ngIf="occupation?.finalSolutionState === FinalSolutionStateEnum.PENDING" class="tag tag--inline is-uppercase tag--not-clickable tag-solution tag-pending">Ke schválení</span>
        </div>
      </td>
      <td *ngIf="!hideColumn('cases')" class="number">{{ occupation.countCases }}</td>
      <td *ngIf="!hideColumn('constructionObjects')" class="no-padding">
        <cell-construction-objects
          [constructionObjects]="occupation.constructionObjects"
          [tooltipType]="'construction-objects'"
          [tooltipData]="{ constructionObjects: occupation.constructionObjects }"
        ></cell-construction-objects>
      </td>
      <td *ngFor="let occupationType of occupationTypesPermanent" class="number">
        <span *ngIf="occupation.zabtyp === occupationType.number">{{ occupation.zabvym }}</span>
      </td>
      <td *ngFor="let occupationType of occupationTypesTemporary" class="number">
        <span *ngIf="occupationType.category === 'rental_length'">{{ occupation.rentalLength }}</span>
        <span *ngIf="occupationType.category !== 'rental_length' && occupation.zabtyp === occupationType.number">{{ occupation.zabvym }}</span>
      </td>
    </tr>
    </tbody>
  </table>
</div>
<div class="empty-info bordered" *ngIf="!list.itemCount && list.list !== null">
  Nenalezena žádná data
</div>
